import "./permissionTable.css";
import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import actions from "../../actions";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getPermissionHistoryTable } from "../../apis";


const PermissionHistoryTable = () => {
  const { id } = useParams();
  const [permissionHistory, setPermissionHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [receiverId,setReceiverId] = useState(null);
  const [viewDate,setViewDate]=useState(null);

  const fetchPermissionHistory = async () => {
    try {
      setLoading(true);
      const response = await getPermissionHistoryTable(id);
      console.log("response",response.data)
      if (response?.data?.data) {
        setPermissionHistory(response.data.data);
      } else {
        setPermissionHistory([]);
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
      setPermissionHistory([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPermissionHistory();
  }, []);

  if (loading) return <div>Loading chat history...</div>;

//   const handleViewChat = ({receiverId,date}) => {
//     setReceiverId(receiverId);
//     setViewDate(date);
//   }

//   if(receiverId){
//     return <ChatHistory receiverId={receiverId} userId={id} date={viewDate} />;
//   }

  return (
    <div className="chat-history-table-container">
      <h2  style={{paddingBottom: "20px"}}>Chat History</h2>
      <table className="chat-history-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>Coach</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {permissionHistory.map((chat, index) => {
    const createdAt = new Date(chat.createdAt);
    const date = createdAt.toLocaleDateString();
    const time = createdAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // HH:MM format

    return (
      <tr key={index}>
        <td>{date}</td>
        <td>{time}</td>
        <td>{chat.coachId.firstName || "NA"} {chat.coachId.lastName}</td>
        <td>{chat.action}</td>
      </tr>
    );
  })}
          {permissionHistory.length === 0 && (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                No chat history available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(PermissionHistoryTable);